import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import config from '../config'


import './login.js'
import './ui.js'

// 引入i18n
import VueI18n from "vue-i18n"
// 这里需要注册使用语言包
Vue.use(VueI18n);
Vue.locale = () => {
};
//引入iview提供的语言包
import zhLocale from "iview/src/locale/lang/zh-CN";
import enLocale from "iview/src/locale/lang/en-US";
import twLocale from "iview/src/locale/lang/zh-TW";

// 引入自定义的语言包
import cn from "@/language/zh-CN";
import tw from "@/language/zh-TW";
import us from "@/language/en-US";
import iView from "iview";
// Vue.use(iView);
Vue.use(iView, {
    i18n: function(path, options) {
        let value = i18n.t(path, options)
        if (value !== null && value !== undefined) {
            return value
        }
        return ''
    }
});
// 自己写的语言包，并封装成对象
const messages = {
    zh: Object.assign(cn, zhLocale),
    en: Object.assign(us, enLocale),
    tc: Object.assign(tw, twLocale)
};

// 设置参数，创建 Vuei18n 的实例。需要将他挂载全局的所有组件上
const i18n = new VueI18n({
    // set locale 本地存储记录当前选中的语言是哪一种/默认的是哪种语言
    locale: localStorage.getItem("language") || "zh",
    messages // set locale messages,在构造器中配置这个语言包
});
Vue.prototype.$config = config;
Vue.prototype.HOST = '/api';
Vue.config.productionTip = false;
Vue.prototype.$Message.config({
    top: 100,
    duration:4
});
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});
//按扭权限指令
Vue.directive('allow', {
    inserted: (el, binding, vnode) => {
        let permissionList = vnode.context.$route.meta.permission;
        if (!permissionList.includes(binding.value)) {
            el.parentNode.removeChild(el)
        }
    }
})
var vm = new Vue({
    el: '#app',
    router,
    store,
    i18n,   //这一步不能少；将这个语言包对象配置给全局组件使用
    template: '<App/>',
    components: {App}
});




// WEBPACK FOOTER //
// ./src/main.js